import React, { Fragment, useState } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'
import set from 'lodash/set'

import ContentBlock from 'components/ContentBlock'
import { Form, Number as NumberInput, Select } from 'components/forms'
import { multiValidate, notEmpty, minMaxFields } from 'helpers/validators'
import listLoyaltyCards from '../../gql/listLoyaltyCards'
import { DataTable } from 'components/DataTable'
import { seriesCards } from '../../tableColumns'
import getSettingOptions from './fragments/getSettingOptions'
import { transformData } from 'components/graphql'
import Button from 'components/Button'
import Divider from 'components/Divider'

const SeriesSetting = ({ onSubmit }) => {
	const [rangeList, setRangeList] = useState()
	const [editingParam, setEditingParam] = useState()
	const [showParamSelect, setShowParamSelect] = useState()
	const [t, i18n] = useTranslation()
	const handleSubmit = vals => {
		const outVals = { ...vals }
		if(!vals.fields) {
			const { defaultValue } = editingParam || {}
			const fieldName = get(editingParam, 'value.props.field')
			if((typeof defaultValue !== 'undefined') && fieldName) {
				set(outVals, fieldName, defaultValue)
			}
		}
		setEditingParam()
		onSubmit(outVals)
	}
	const handleListFetched = fetchData => {
		const preparedData = transformData(fetchData, { queryFieldExtract: true })
		const items = get(preparedData, 'data.items', [])
		if(items.length) {
			setShowParamSelect(true)
		} else {
			setShowParamSelect(false)
		}
	}
	return(
		<ContentBlock label={t('loyalty_card_section.strings.settings')}>
			<Form onSubmit={handleSubmit}>
				{({ formState, formApi }) => {
					const { from, to } = get(formState, 'values.ids', {})
					const handleBlur = field => e => {
						const errorRange = get(formState, 'errors.ids')
						const newVal = e.target.value
						const prevVal = formApi.getValue(field)
						const isValChanged = newVal !== prevVal
						const isRange = from && to
						if(isValChanged && isRange && !errorRange) {
							setRangeList({ from, to })
						}
					}

					return(
						<Row>
							<Col xs={6}>
								<p className='form-group-label'>{t('loyalty_card_section.strings.select_loyalty_cards')}</p>
								<NumberInput
									field='ids.from'
									label={t('common.strings.from')}
									placeholder={t('common.strings.from')}
									{...multiValidate([notEmpty(), minMaxFields('min', 'ids.to')])}
									inline
									shrink
									withControls={false}
									onBlur={handleBlur('ids.from')}
								/>
								<NumberInput
									field='ids.to'
									label={t('common.strings.to')}
									placeholder={t('common.strings.to')}
									{...multiValidate([notEmpty(), minMaxFields('max', 'ids.from')])}
									inline
									shrink
									withControls={false}
									onBlur={handleBlur('ids.to')}
								/>
								<DataTable
									{...rangeList
										? {
											remoteOptions: {
												query: listLoyaltyCards,
												filter: { rangeIds: rangeList },
												skip: !rangeList,
												onCompleted: handleListFetched
											}
										}
										: { data: [] }
									}
									columns={seriesCards}
									withSearch
									height={188}
								/>
								<Divider />
								<Button type='submit' text={t('common.buttons.apply')} status={editingParam ? 'primary' : 'inactive'} />
							</Col>
							<Col xs={6}>
								{showParamSelect &&
									<Fragment>
										<Select
											noForm
											value={editingParam ? editingParam.value : null}
											label={t('loyalty_card_section.strings.select_config')}
											options={getSettingOptions(t, i18n)}
											onChange={val => setEditingParam(val)}
										/>
										{(editingParam && editingParam.field) && editingParam.field}
									</Fragment>
								}
							</Col>
						</Row>
					)
				}}
			</Form>
		</ContentBlock>
	)
}

export default SeriesSetting
